import React, { useState, useEffect } from 'react';
import './feedbackpage.css';

const FeedbackDashboard = () => {
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [feedbackData, setFeedbackData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [submittedRange, setSubmittedRange] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [showUsername, setShowUsername] = useState(true);
    const [showComments, setShowComments] = useState(true);
    const [showRating, setShowRating] = useState(true);
    const [showEmailID, setShowEmailID] = useState(true);
    const [showTrans, setShowTrans] = useState(true);
    const [translations, setTranslations] = useState({});
    const [loadingRows, setLoadingRows] = useState({});
    const [hoveredRow, setHoveredRow] = useState(null);
    const [currentSessionid, setcurrentSessionid] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [currentTranscript, setCurrentTranscript] = useState('');


    // useEffect(() => {
    //     const handleScroll = () => {
    //         const footer = document.querySelector('footer');
    //         if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
    //             footer.style.display = 'block';
    //         } else {
    //             footer.style.display = 'none';
    //         }
    //     };

    //     window.addEventListener('scroll', handleScroll);
    //     return () => {
    //         window.removeEventListener('scroll', handleScroll);
    //     };
    // }, []);

    const fetchFeedbackData = async (start, end) => {
        setIsLoading(true);
        setTranslations({});
        try {
            const response = await fetch(`/api/feedback`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ start, end }),
            });
            const result = await response.json();
            console.log(JSON.stringify(result.result));

            setFeedbackData(result.result);
            translateAll(result.result);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const showtransbyid = async (start, end, id) => {
        console.log("idddd=", id);
        setcurrentSessionid(id)
        try {
            const response = await fetch(`/api/transcript?sessionid=${id}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ start, end }),
            });
            const result = await response.json();
            console.log(JSON.stringify(result.result));
            setCurrentTranscript(result.transcript);
            setShowModal(true);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
        }
    };

    const formatTextWithBold = (obj) => {
        let text = obj?.transcript || ""
        console.log("here=", text);
        const boldedText = text.replace(/\*\*(.*?)\*\*/g, (match, p1) => `<strong>${p1}</strong>`);
        const withParagraphs = boldedText.replace(/\n\n/g, '</p><p>');
        const formattedText = withParagraphs.replace(/\n/g, '<br />');
        return `<p>${formattedText}</p><br><br>`;
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };
    const handleSubmitDateRange = async () => {
        if (startDate && endDate) {
            console.log(`Fetching feedback from ${startDate} to ${endDate}`);
            setSubmittedRange(`${startDate} - ${endDate}`);
            fetchFeedbackData(startDate, endDate);
        } else {
            alert('Please select both start and end dates.');
        }
    };

    const handleDownloadExcel = async () => {
        if (startDate && endDate) {
            try {
                const response = await fetch(`/api/fetch_details`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ startDate, endDate }),
                });

                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }

                const blob = await response.blob();

                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `From_${startDate}_to_${endDate}.xlsx`;

                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);

                window.URL.revokeObjectURL(url);

            } catch (error) {
                console.error('Error fetching data:', error);
            }
        } else {
            alert('Please select both start and end dates.');
        }
    };

    const filteredFeedbackData = feedbackData.filter((feedback) => {
        const query = searchQuery.toLowerCase();
        const name = feedback.name ? feedback.name.toLowerCase() : '';
        const feedbackText = feedback.feedback ? feedback.feedback.toLowerCase() : '';
        const rating = feedback.rating ? feedback.rating.toString() : '';
        const emailID = feedback.emailID ? feedback.emailID.toLowerCase() : '';

        return (
            name.includes(query) ||
            feedbackText.includes(query) ||
            rating.includes(query) ||
            emailID.includes(query)
        );
    });

    const translateAll = async (feedbacks) => {
        try {
            const response = await fetch("/api/translate", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    texts: feedbacks.map(item => item.feedback),
                }),
            });

            const data = await response.json();

            const results = {};

            data.forEach((item, index) => {
                results[index] = {
                    language: item.detectedLanguage.language,
                    translation:
                        item.detectedLanguage.language !== "en"
                            ? item.translations[0].text
                            : null,
                    showTranslation: false,
                };
            });

            setTranslations(results);

        } catch (error) {
            console.error("Translation error:", error);
        }
    };
    return (
        <>
            <h1 style={{ textAlign: "center", fontSize: "2rem", color: "#333", marginBottom: "20px", marginTop: "20px" }}>Feedback Dashboard</h1>
            <div className="container">
                <div className="datepickercontainer">
                    <div className="date-picker">
                        <div className="startdate">
                            <label htmlFor="start-date-picker">Start date:</label>
                            <input
                                type="date"
                                id="start-date-picker"
                                name="start-date-picker"
                                value={startDate}
                                onChange={(e) => setStartDate(e.target.value)}
                            />
                        </div>
                        <div className="enddate">
                            <label htmlFor="end-date-picker">End date:</label>
                            <input
                                type="date"
                                id="end-date-picker"
                                name="end-date-picker"
                                value={endDate}
                                onChange={(e) => setEndDate(e.target.value)}
                            />
                        </div>
                    </div>
                    <button onClick={handleSubmitDateRange}>Submit</button>
                    <button onClick={handleDownloadExcel}>Download Excel</button>
                </div>
                {isLoading && <p>↺</p>}
                {/* Modal for Transcript */}
                {showModal && (
                    <div className="modal-overlay">
                        <div className="modal-content">
                            <div className="modal-header">
                                Session ID : {currentSessionid}
                            </div>
                            <button className="close-modal" onClick={handleCloseModal}>
                                &times; Close
                            </button>
                            <div className="modal-transcript">
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: formatTextWithBold(currentTranscript[0]),
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                )}

                <div className="feedbacks">
                    <div className="feedbackscontents">
                        <h2>Feedbacks</h2>
                        <label htmlFor="username"></label>
                        <input
                            type="text"
                            id="username"
                            name="username"
                            placeholder="Search"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                        />
                        <div className="togglescreen">
                            <label>
                                <input
                                    type="checkbox"
                                    checked={showUsername}
                                    onChange={() => setShowUsername(!showUsername)}
                                />
                                Show Username
                            </label>
                            <label>
                                <input
                                    type="checkbox"
                                    checked={showComments}
                                    onChange={() => setShowComments(!showComments)}
                                />
                                Show Feedback
                            </label>
                            <label>
                                <input
                                    type="checkbox"
                                    checked={showRating}
                                    onChange={() => setShowRating(!showRating)}
                                />
                                Show Rating
                            </label>
                            <label>
                                <input
                                    type="checkbox"
                                    checked={showEmailID}
                                    onChange={() => setShowEmailID(!showEmailID)}
                                />
                                Show EmailID
                            </label>
                            <label>
                                <input
                                    type="checkbox"
                                    checked={showTrans}
                                    onChange={() => setShowTrans(!showTrans)}
                                />
                                Show Transcript
                            </label>
                        </div>
                        {submittedRange && <p>{submittedRange}</p>}
                        <div className="table-container">
                            <table className="feedback-table">
                                <thead>
                                    <tr>
                                        {showEmailID && <th>Username</th>}
                                        {/* {showUsername && <th>Username</th>} */}
                                        {showComments && <th>Feedback</th>}
                                        {showRating && <th>Rating</th>}
                                        {showTrans && <th>Transcript</th>}
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredFeedbackData.length > 0 ? (
                                        filteredFeedbackData.map((feedback, index) => (
                                            <tr key={index}>
                                                {/* {showUsername && <td>{feedback.name}</td>} */}
                                                {showEmailID && <td>{feedback.emailID}</td>}

                                                {showComments && (
                                                    <td style={{ position: "relative" }}>
                                                        <span>
                                                            {translations[index]?.showTranslation
                                                                ? translations[index].translation
                                                                : feedback.feedback}
                                                        </span>

                                                        {translations[index]?.language !== "en" &&
                                                            !translations[index]?.showTranslation && (
                                                                <button
                                                                    style={{
                                                                        position: "absolute",
                                                                        right: "10px",
                                                                        top: "50%",
                                                                        transform: "translateY(-50%)",
                                                                        border: "none",
                                                                        background: "transparent",
                                                                        cursor: "pointer",
                                                                        fontSize: "18px",
                                                                    }}
                                                                    title="Translate"
                                                                    onClick={() =>
                                                                        setTranslations(prev => ({
                                                                            ...prev,
                                                                            [index]: {
                                                                                ...prev[index],
                                                                                showTranslation: true,
                                                                            },
                                                                        }))
                                                                    }
                                                                >
                                                                    🌐
                                                                </button>
                                                            )}
                                                    </td>
                                                )}

                                                {showRating && (
                                                    <td>
                                                        {feedback.rating.includes("usernotsatisfied")
                                                            ? "👎"
                                                            : feedback.rating.includes("usersatisfied")
                                                                ? "👍"
                                                                : feedback.rating}
                                                    </td>
                                                )}



                                                {
                                                    showTrans && <td>
                                                        <button onClick={() => showtransbyid(startDate, endDate, feedback.id)}>View Transcript</button>
                                                    </td>
                                                }
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={4}>No feedback available.</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <footer>
                    <div className="footer-content">
                        <p></p>
                    </div>
                </footer>
            </div>
        </>
    );
};

export default FeedbackDashboard;
